import styled from 'styled-components'

export const MaxCount = styled.span`
  justify-content: center;
  flex-direction: row;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
`

export const MaxCountText = styled.span`
  margin-right: 10px;
`
